import styles from './styles.module.scss';
import React from 'react';
import { navigateToProjectDetail } from 'src/utils/navigate';
import PrivateSaleProvider from '../ProjectDetailPage/Components/ProjectPanel/PrivateSaleProvider';
import ConfirmationModal from './Components/ConfirmationModal';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { useLocation, useParams } from 'react-router-dom';
import { getProjectDetail } from 'src/redux/actions';
import { ProjectStatus } from 'src/utils/types';
import PageContent from 'src/Components/PageContent';
import { AppError } from 'src/redux/types';
import { parseLocation } from './utils';
import Spinner from 'src/Components/Spinner';
import EmptyList from 'src/Components/EmptyList';
import BackButton from 'src/Components/BackButton';

const ProjectConfirmationPage = () => {
  const dispatch = useTypedDispatch();
  const params = useParams();
  const location = useLocation();
  const parsedLocation = parseLocation(location.state);
  const projectDetail = useTypedSelector(state => state.projectDetail.data);
  const error = useTypedSelector(state => state.projectDetail.error);
  const loading = useTypedSelector(state => state.projectDetail.loading);
  const invalidated = useTypedSelector(state => state.projectDetail.invalidated);
  React.useEffect(() => {
    if (!projectDetail) {
      dispatch(getProjectDetail(params.id));
    }
  }, [dispatch, params.id, projectDetail]);
  React.useEffect(() => {
    if (projectDetail && projectDetail.projectStatus !== ProjectStatus.LIVE) {
      navigateToProjectDetail(params.id);
    }
  }, [params.id, projectDetail, projectDetail === null || projectDetail === void 0 ? void 0 : projectDetail.projectStatus]);
  React.useEffect(() => {
    if (!parsedLocation.isAgreed) {
      navigateToProjectDetail(params.id);
      return;
    }

    window.history.replaceState(null, '');
  }, [params.id, parsedLocation.isAgreed]);

  const renderContent = () => /*#__PURE__*/React.createElement(PrivateSaleProvider, null, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(BackButton, {
    onClick: () => navigateToProjectDetail(params.id),
    label: "Go Back",
    className: styles.backBtn
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.detail
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.headingText
  }, "Private sales confirmation"), projectDetail && /*#__PURE__*/React.createElement(ConfirmationModal, {
    projectDetail: projectDetail
  })))));

  const renderLoading = () => {
    return /*#__PURE__*/React.createElement(Spinner, null);
  };

  const renderError = () => {
    return /*#__PURE__*/React.createElement(EmptyList, null);
  };

  return /*#__PURE__*/React.createElement(PageContent, {
    error: error !== AppError.NO_ERROR,
    invalidated: invalidated,
    loading: loading,
    renderContent: renderContent,
    renderError: renderError,
    renderLoading: renderLoading
  });
};

export default ProjectConfirmationPage;